import { z } from 'zod';
/**
 * The one phone-number shape the platform accepts on a write.
 *
 * E.164 and nothing else: `PhoneInput` (`packages/ui`) emits exactly this from
 * every phone field in both SPAs, and a looser rule would store a number no
 * carrier can route — then bill us for the SMS attempt when someone tries.
 *
 * `+`, a non-zero country-code digit, then 7 to 14 more. The upper bound is
 * ITU-T E.164's 15-digit maximum; the lower bound rejects a bare country code
 * with a digit or two behind it without pretending to know national numbering
 * plans, which this deliberately does not (see `packages/ui/src/lib/e164.ts` —
 * whether a well-formed number is REACHABLE is not a question a regex answers).
 *
 * READ schemas stay `z.string().nullable()` on purpose. A DTO must be able to
 * parse whatever is already in the column; tightening the output shape turns a
 * legacy row into a 500 on a page that only wanted to display it.
 */
export const E164_REGEX = /^\+[1-9]\d{7,14}$/;
/**
 * A required E.164 number.
 *
 * `E164_MAX_LENGTH` is redundant against the regex — nothing the regex accepts
 * is longer — and is declared anyway so that `schema.maxLength` reads back as a
 * number. Both SPAs derive the field's `maxLength` message from the contract
 * (`createPersonSchema.innerType().shape.phone...maxLength`) rather than
 * restating a bound the schema already owns, and a `null` there would silently
 * drop that message.
 */
export const E164_MAX_LENGTH = 16;
export const e164Schema = z.string().regex(E164_REGEX).max(E164_MAX_LENGTH);
/**
 * An optional E.164 number, as every phone column in the directory and visitor
 * models is. `''` is not a phone number: `PhoneInput` emits `''` for an empty
 * field and each form normalizes that to `null` before it reaches the wire, so
 * the empty string never needs to be a valid value here.
 */
export const optionalE164Schema = e164Schema.nullable().default(null);
//# sourceMappingURL=phone.js.map